export default "__VITE_ASSET__004e1098__"